import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, App } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';
import { login } from '../../services/auth.api';
import type { LoginParams } from '../../services/auth.api';
import { UserRole } from '@talent-week/shared-types';

const { Title, Text } = Typography;

/**
 * 登录页
 *
 * 管理端登录界面，支持用户名+密码登录。
 */
const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { login: storeLogin, setLoading } = useAuthStore();
  const [loading, setLoadingState] = useState(false);

  const onFinish = async (values: LoginParams) => {
    setLoadingState(true);
    setLoading(true);

    try {
      const result = await login(values);
      storeLogin(result.accessToken, {
        id: result.user.id,
        username: result.user.username,
        name: result.user.name,
        role: result.user.role as UserRole,
      });
      message.success('登录成功');
      navigate('/dashboard');
    } catch (error: any) {
      message.error(error.message || '登录失败');
    } finally {
      setLoadingState(false);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Card
        style={{
          width: 420,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
          borderRadius: 12,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ marginBottom: 8 }}>
            人才周管理平台
          </Title>
          <Text type="secondary">
            2026 华罗庚常州国际人才周
          </Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
          initialValues={{ username: '', password: '' }}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center' }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            请联系管理员开通账号
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
